import React, { useState } from 'react';
import { reportTypes } from '../data/reportData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiClock, FiLock, FiArrowRight, FiFileText } = FiIcons;

const ReportSelector = () => {
  const [selectedId, setSelectedId] = useState('standard');
  const AFFILIATE_LINK = "https://learn.augustapreciousmetals.com/apm-aff-lp-1-v3?apmtrkr_cid=1696&aff_id=5283&sub_id=YOUR_IDENTIFIER";

  return (
    <section id="report-builder" className="py-24 bg-slate-900 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-500/10 rounded-full blur-[120px]"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-[120px]"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 font-serif"> Customize Your <span className="text-yellow-400">Wealth Protection</span> Report </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto"> Select the report length that best fits your research needs. Our institutional-grade reports are updated weekly for 2026 market conditions. </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {reportTypes.map((report) => (
            <button key={report.id} onClick={() => setSelectedId(report.id)} className={`text-left p-8 rounded-3xl border-2 transition-all duration-300 relative group ${selectedId === report.id ? 'bg-slate-800 border-yellow-400 shadow-[0_0_30px_rgba(234,179,8,0.15)] ring-4 ring-yellow-400/5' : 'bg-slate-850 border-slate-700 hover:border-slate-500'}`} >
              {report.premium && (
                <div className="absolute top-4 right-4 flex items-center gap-1 px-2 py-1 bg-yellow-400/20 text-yellow-400 rounded-md text-[10px] font-bold uppercase tracking-widest">
                  <SafeIcon icon={FiLock} className="text-[10px]" /> Premium
                </div>
              )}
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 transition-colors ${selectedId === report.id ? 'bg-yellow-400 text-slate-900' : 'bg-slate-700 text-slate-300'}`}>
                <SafeIcon icon={FiFileText} className="text-2xl" />
              </div>
              <h3 className={`text-xl font-bold mb-2 ${selectedId === report.id ? 'text-white' : 'text-slate-100'}`}> {report.title} </h3>
              <div className="flex items-center gap-2 text-sm text-slate-400 mb-4">
                <SafeIcon icon={FiClock} className="text-yellow-500/70" />
                <span>{report.duration}</span>
              </div>
              <p className={`text-sm leading-relaxed mb-6 ${selectedId === report.id ? 'text-slate-200' : 'text-slate-400'}`}> {report.description} </p>
              <ul className="space-y-3">
                {report.includes.map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-xs font-medium text-slate-300">
                    <SafeIcon icon={FiCheck} className="text-yellow-400 mt-0.5 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
              {selectedId === report.id && (
                <div className="mt-8 pt-6 border-t border-slate-700 animate-fadeIn">
                  <span className="text-yellow-400 text-sm font-bold flex items-center gap-2"> Selected for Delivery <SafeIcon icon={FiArrowRight} /> </span>
                </div>
              )}
            </button>
          ))}
        </div>
        <div className="bg-slate-800 p-8 rounded-3xl border border-slate-700 max-w-4xl mx-auto shadow-2xl">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-grow text-center md:text-left">
              <h4 className="text-2xl font-bold text-white mb-2">Ready to receive your {reportTypes.find(r => r.id === selectedId)?.title}?</h4>
              <p className="text-slate-300">Enter your details below to have the digital dossier sent to your secure inbox.</p>
            </div>
            <a href={AFFILIATE_LINK} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 inline-flex items-center justify-center px-8 py-4 bg-yellow-400 text-slate-900 font-bold rounded-xl hover:bg-yellow-300 hover:scale-105 transition-all shadow-lg text-lg" >
              Request Selected Report
              <SafeIcon icon={FiArrowRight} className="ml-2" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReportSelector;